import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import LinkwithModal from '../LinkWithModal';

export const StSecondaryLinks = styled(LinkwithModal, {
  shouldForwardProp: (prop) => prop !== 'linkFontColor' && prop !== 'hoverColor',
})<{
  linkFontColor?: string;
  hoverColor?: string;
  isDefaultApp?: boolean;
}>(({ theme, linkFontColor, hoverColor, isDefaultApp }) => ({
  fontFamily: theme?.palette?.primaryFontFamilyType || 'Proxima Nova',
  fontStyle: 'normal',
  fontWeight: isDefaultApp ? 400 : 500,
  fontSize: '14px',
  lineHeight: isDefaultApp ? '21px !important' : '18px !important',
  textAlign: 'center',
  letterSpacing: isDefaultApp ? '0.28px' : '0.5px',
  color: linkFontColor ? linkFontColor : theme.palette.white.main,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    borderBottom: '1px dashed',
    color: hoverColor || theme.palette.white.main,
  },
  '&:active': {
    fontWeight: 600,
    textDecoration: 'none',
  },
}));

export const StSecondaryLinkItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    marginBottom: '0.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '0.5rem',
  },
}));

export const StLinkSeprator = styled('span', {
  shouldForwardProp: (prop) => prop !== 'linkFontColor',
})<{
  linkFontColor?: string;
  isDefaultApp?: boolean;
}>(({ theme, linkFontColor, isDefaultApp }) => ({
  height: '18px',
  [theme.breakpoints.up('sm')]: {
    marginRight: isDefaultApp ? '0.8125rem' : '0.5rem',
    paddingRight: isDefaultApp ? '0.8125rem' : '0.5rem',
    borderRight: `1px solid ${linkFontColor || '#D9D9D9'} !important`,
  },
}));
